import {ReactNode} from "react";
import {DibJsonNode} from "../../types";
import {usePanel} from "../../panel/PanelContext";
import contentLinkClasses from "../contentLink.module.css";

export const AutoLink = ({
    node,
    children,
    rootTopicId,
}: {
    node: DibJsonNode;
    children: ReactNode[];
    rootTopicId?: string;
}) => {
    const {openPanel} = usePanel();

    if (!node.object || !(node.object.type === "linkdata")) {
        return <span>{children}</span>;
    }

    const queryParams = {
        resourceId: "",
        segmentId: "",
        id: "",
    };

    switch (node.object.data.type) {
        case "auto-link": {
            const qpResource = rootTopicId ?? "UNKNOWN";
            const qpSegment = "auto-link"; // Hard coded value by design.
            const qpId = node.object.id; // Object id for the link itself.
            queryParams.resourceId = qpResource;
            queryParams.segmentId = qpSegment;
            queryParams.id = qpId;
            break;
        }
        case "preview":
            queryParams.resourceId = node.object.data.topicId;
            queryParams.segmentId = node.object.data.segmentId ?? "";
            queryParams.id = node.object.data.id;
            break;
        default:
    }

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        openPanel({
            label: "Auto-link",
            fetchType: "documentParts",
            params: {
                resourceId: queryParams.resourceId,
                segmentId: queryParams.segmentId,
                id: queryParams.id,
            },
        });
    };

    return (
        <a href="#" className={contentLinkClasses.panelLink} onClick={handleClick}>
            {children}
        </a>
    );
};
